import DOMPurify from "dompurify"

import { addTargetBlankToLinks } from "@productlane/lib/src/html"

import { lruCached } from "./lru-cache"

// Every timeline render sanitizes every Slack, chat and thread message; the
// result depends only on the html, so a thread switch back reuses it.
const CACHE_LIMIT = 256
const cache = new Map<string, string>()

export const sanitizeMessageHtml = (html: string) =>
	lruCached(cache, CACHE_LIMIT, html, () =>
		addTargetBlankToLinks(DOMPurify.sanitize(html)),
	)
